import { ListItemText } from "@material-ui/core";
import styled from "styled-components";

export const StyledPasswordCheck = styled(ListItemText) <{ isEnabled: boolean | string[] }>`
    && {
        color: ${props => props.isEnabled ? props.theme.colors.success : 'currentColor'};
    }

    && * {
        font-size: 0.9rem !important;
    }
`